import React from 'react'
import { LoadingComponent } from '@pga/pga-component-library'

const IsLoading = ({ isLoading }) => isLoading ? <LoadingComponent data-testid='loading-component' /> : null

export default IsLoading
